import { render, staticRenderFns } from "./Electionlisting.vue?vue&type=template&id=f83b2b52&scoped=true"
import script from "./Electionlisting.vue?vue&type=script&lang=js"
export * from "./Electionlisting.vue?vue&type=script&lang=js"
import style0 from "./Electionlisting.vue?vue&type=style&index=0&id=f83b2b52&prod&scoped=true&lang=css"
import style1 from "./Electionlisting.vue?vue&type=style&index=1&id=f83b2b52&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83b2b52",
  null
  
)

export default component.exports